export const LEAD_STATUS_VALUES = [
  "New",
  "Contacted",
  "Discovery",
  "Proposal",
  "Client",
  "Lost",
  "Do not contact",
];

export const LEAD_STATUS_OPTIONS = LEAD_STATUS_VALUES.map((status) => ({
  value: status,
  label: status,
}));
